import './Partials/menu';
import './Partials/footer';
import './Partials/base';

import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

// Initialise alpine
Alpine.plugin(collapse);
Alpine.start();

import { reactComponentArray } from './React/index';

reactComponentArray();
if (document.querySelector('.mypages-view')) {
  import('./Pages/my-pages').then(function (page) {
    page.render();
  });
}
if (
  document.getElementById('MyPagesValueCheck') != null ||
  document.getElementById('MyPagesHome') != null
) {
  import('./Pages/valueChart').then(function (page) {
    page.render();
  });
}
if (document.querySelector('.splide') != null) {
  import('./Blocks/information-block').then(function (page) {
    page.render();
  });
}
if (document.querySelector('.HotspotBlock') != null) {
  import('./Blocks/hotspot').then(function (page) {
    page.render();
  });
}

if (document.querySelector('.MilestonesBlock') != null) {
  import('./Blocks/milestones').then(function (page) {
    page.render();
  });
}

if (
  document.getElementById('OfficePage') != null ||
  document.getElementById('officeListPage') != null
) {
  import('./Pages/office').then(function (page) {
    page.render();
  });
}

if (document.getElementById('ContentFullScroll') != null) {
  import('./Pages/full-page-content').then(function (page) {
    page.render();
  });
}
if (document.getElementById('DictionaryPage') != null) {
  import('./Pages/dictionary').then(function (page) {
    page.render();
  });
}

if (
  document.getElementById('VacantJobs') != null ||
  document.getElementById('VacantJob') != null ||
  document.getElementById('CareerPossibility') != null
) {
  import('./Pages/career').then(function (page) {
    page.render();
  });
}

if (document.getElementById('mypages-menu-button') != null) {
  import('./MyPages/mainmenu').then(function (page) {
    page.render();
  });
}

if (document.getElementById('heroVideo') != null) {
  import('./Partials/initPlayPauseToggle').then(function (page) {
    page.initPlayPauseToggle();
  });
}
